import { render, staticRenderFns } from "./VideoInteractive.vue?vue&type=template&id=678504d8"
import script from "./VideoInteractive.vue?vue&type=script&lang=js"
export * from "./VideoInteractive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports